import * as React from 'react';
export const shopeepaySvg = React.forwardRef(function shopeepaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EE4D2D',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.921 8.199c4.425-.394 8.85-.781 13.275-1.176.187-.013.373-.048.553.007.346.097.616.443.595.802v1.314c.02.152-.09.263-.16.373-.352.042-.698.028-1.05.028H8.613c-.263-.035-.491.242-.415.498.062.394.435.719.836.705 5 0 10.005-.007 15.004 0 .974 0 1.832.878 1.818 1.853v10.571c.007.962-.85 1.826-1.818 1.826H7.99c-.968.014-1.839-.85-1.839-1.826-.007-4.334 0-8.67-.007-13.005-.007-.38.076-.76.277-1.085.31-.512.892-.85 1.5-.885Zm5.711 5.607c-.484.498-.74 1.224-.636 1.915.07.581.408 1.1.85 1.466.609.525 1.404.747 2.137 1.037.733.235 1.507.505 2.026 1.106.325.36.47.885.331 1.356-.13.525-.573.92-1.064 1.12a3.253 3.253 0 0 1-1.936.159c-.768-.152-1.466-.526-2.074-1.01-.215-.131-.298.187-.415.304-.062.139-.311.318-.152.47.836.74 1.929 1.155 3.035 1.245.92.09 1.908-.09 2.655-.664.947-.726 1.293-2.178.684-3.222-.47-.753-1.293-1.182-2.08-1.52-.837-.374-1.805-.52-2.51-1.142-.395-.331-.602-.884-.45-1.382.2-.72.934-1.155 1.639-1.224.705-.062 1.424.097 2.067.38.263.11.498.29.76.401.132-.221.312-.422.402-.67.048-.097-.07-.16-.132-.208a5.164 5.164 0 0 0-2.91-.823c-.81-.007-1.653.304-2.227.906Z',
      fill: '#fff',
    }),
  );
});
shopeepaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var shopeepay = {
  category: 'brand',
  colorable: false,
  name: 'shopeepay',
  svg: shopeepaySvg,
};
